module.exports = __webpack_public_path__ + "static/media/myBookings.6cc377e7.svg";